// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import $ from 'jquery'
//import axios from 'axios'
import http from './api/ajax'
import qs from 'qs'

import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'

import App from './App'
import router from './router'

import './assets/css/base.css'

Vue.config.productionTip = false;

Vue.prototype.$http = http;
Vue.use(ElementUI);
Vue.use(echarts);
Vue.prototype.$echarts = echarts;
Vue.prototype.$ = $;
Vue.prototype.$qs = qs;

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.needLog)) {
    //为页面赋值title
    if(to.meta.title){
      document.title = to.meta.title
    }
    //页面是否登录
    if (localStorage.getItem("zero_token")) {
      //本地存储中是否有token(uid)数据
      let nav = localStorage.getItem("navBar");//后台返回权限
      let navs =  JSON.parse(localStorage.getItem("navs"));//预定义好的数组
      console.log(navs);
      if(nav != '' && nav != null && nav != undefined && nav.length != 0){
        if(navs && navs.length != 0){

        }
      }
      next(); //表示已经登录
    } else {
      //next可以传递一个路由对象作为参数 表示需要跳转到的页面
      next({
        path: "/log"
      });
    }
  } else {
    //表示不需要登录
    next(); //继续往后走
  }
});
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});


/*axios.post('http://139.9.165.66:8083/login/login',{username: 'q12345678',password: '12345678'}).then(res=>{
  console.log(res);
});*/


//请求
//默认为get请求

/*axios({
  url: 'http://139.9.165.66:8083/login/login',
  method: 'get',
  params: {
    username: 'q12345678',
    password: '12345678'
  }
}).then( res => {
  console.log(res);
});*/

/*axios({
  url: 'http://www.phonegap100.com/appapi.php',
  method: 'post',
  data: {
    username: 'getPortalList',
    password: '20',
    page: '0000'
  }
}).then( res => {
  console.log(res);
});*/

//做一个功能时需要发送两个请求，两个请求同时到达才能继续写(并发请求)
/*
axios.all([axios({
  url: 'http://www.phonegap100.com/appapi.php',
  method: 'post',
  params: {
    a: 'getPortalList',
    catid: '20',
    page: '1'
  }
}),axios({
  url: 'http://www.phonegap100.com/appapi.php',
  method: 'post',
  params: {
    a: 'getPortalList',
    catid: '20',
    page: '2'
  }
})]).then( res => {
  console.log(res);
});*/

//配置全局信息
//axios.defaults.baseURL = 'http://www.phonegap100.com';

/*axios.all([axios({
  url:'/appapi.php?a=getPortalList&catid=20&page=1'
}),axios({
  url:'/appapi.php?a=getPortalList&catid=20&page=2'
})]).then( axios.spread( (res1,res2) => {
  console.log(res1);
  console.log(res2);
}));*/

/*axios.all([axios({
  url:'/appapi.php',
  method: 'post',
  data: {
    a: 'getPortalList',
    catid: '20',
    page: '1'
  }
}),axios({
  url:'/appapi.php',
  method: 'post',
  data: {
    a: 'getPortalList',
    catid: '20',
    page: '2'
  }
})]).then( axios.spread( (res1,res2) => {
  console.log(res1);
  console.log(res2);
}));*/


/*

//对象解构
const obj = {
  name: '1',
  age: 30
};

const {name,age} = obj;

//数组解构
const arr = ['1','2','3'];

/!*const arr1 = arr[0];
const arr2 = arr[1];
const arr3 = arr[2];*!/

const [arr1,arr2,arr3] = arr;
*/

//get请求为params,post请求为data








// WEBPACK FOOTER //
// ./src/main.js